import { getDatabase } from '@firebase/database';
import { getFirestore } from '@firebase/firestore';
import { getFunctions } from '@firebase/functions';
import { getAuth } from '@firebase/auth';
// import { getAnalytics } from '@firebase/analytics';
import React from 'react'
import { FirestoreProvider, DatabaseProvider, FunctionsProvider, AuthProvider, useFirebaseApp } from 'reactfire';

import firebaseContext from './context';

const providers = {
  firestore: [FirestoreProvider, getFirestore],
  database: [DatabaseProvider, getDatabase],
  functions: [FunctionsProvider, getFunctions],
  auth: [AuthProvider, getAuth],
}

const FirebaseSDK = ({ children }) => {
  const [activeSDK, setActiveSDK] = React.useState(['firestore']);
  const app = useFirebaseApp()
  const handleAddSdk = (sdk) => {
    const arrAdk = (Array.isArray(sdk) ? sdk : [sdk]).filter(s => !activeSDK.includes(s));
    setActiveSDK([...activeSDK, ...arrAdk])
  }
  return (
    <firebaseContext.Provider value={{ addSdk: handleAddSdk, activeSDK }}>
      {activeSDK.reduce((ele, sdk) => {
        const [Provider, getter] = providers[sdk]
        return (
          <Provider sdk={getter(app)}>{ele}</Provider>
        )
      }, children)}
    </firebaseContext.Provider>
  )
}

export default FirebaseSDK
